export const DBConfig = {
  name: 'candidate-db',
  version: 1,
  objectStoresMeta: [
    {
      store: 'tags',
      storeConfig: { keyPath: 'id', autoIncrement: true },
      storeSchema: [
        { name: 'name', keypath: 'name', options: { unique: false } },
        { name: 'color_fg', keypath: 'color_fg', options: { unique: false } },
        { name: 'color_bg', keypath: 'color_bg', options: { unique: false } },
        { name: 'feature', keypath: 'feature', options: { unique: false } },
        {
          name: 'created_by',
          keypath: 'created_by',
          options: { unique: false },
        },
        { name: 'org_id', keypath: 'org_id', options: { unique: false } },
        {
          name: 'updated_at',
          keypath: 'updated_at',
          options: { unique: false },
        },
      ],
    },
    {
      store: 'tags-expiry',
      storeConfig: { keyPath: 'feature', autoIncrement: false }, // Add autoIncrement: false
      storeSchema: [
        {
          name: 'lastFetched',
          keypath: 'lastFetched',
          options: { unique: false },
        },
        { name: 'data', keypath: 'data', options: { unique: false } },
      ],
    },
  ],
}
